// src/components/About.js

import React from "react";
import Typewriter from 'typewriter-effect'

export default function About() {
  return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            I'm Sam Pomerantz
            <br className="hidden lg:inline-block" />
          </h1>
          <p className="mb-8 leading-relaxed">
            <Typewriter options={{loop:true,}}
              onInit={(typewriter) => {
                //typewriter.typeString("I'm a ");
                typewriter.typeString("Senior at Boston University")
                typewriter.pauseFor(500)
                typewriter.deleteAll()
                typewriter.typeString("Computer Science and Finance Major")
                typewriter.pauseFor(500)
                typewriter.deleteAll()
                typewriter.typeString("Incoming SDE @ Amazon")
                typewriter.pauseFor(500)
                typewriter.deleteAll()
                typewriter.start();
              }}
            />
          </p>
          <div className="flex flex-wrap justify-center"> 
            <a
              href="https://sampom100.github.io/resume_selector/cs_resume.pdf" target="_blank"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg mr-4 mb-4">
              Resume
            </a>
            <a
              href="https://www.linkedin.com/in/pomerantzsam/" target="_blank"
              className="inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg mr-4 mb-4">
              LinkedIn
            </a>
            <a
              href="https://www.github.com/sampom100/" target="_blank"
              className="inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg mr-4 mb-4">
              GitHub
            </a>
            <a
              href="mailto:sam@sampomerantz.me" target="_blank"
              className="inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg mr-4 mb-4">
              Email
            </a>
          </div>
        </div>
        <div className="lg:w-1/2lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded-full"
            alt="hero"

            src={process.env.PUBLIC_URL + "/tiny/maybeProfile.webp"}
          />
        </div>
      </div>
    </section>
  );
}